import api from '../../services/serviceBase'

export default {
    GetResourceDocumentList(practice){
        return api.execute('get', `/User/ResourceDocumentList?practiceCode=${practice}`)
    },
    GetAssignDocumentMsgTemplate(login,documentId){
        return api.execute('get', `/User/ResourceDocument?login=${login}&documentId=${documentId}`)
    },
    saveAndSendDocumentSummary(AssignDocument){
        return api.execute('post', `/User/SaveAndSendResourceDocument`,AssignDocument)
    },
}